import { render, staticRenderFns } from "./LegBonusUpdateForm.vue?vue&type=template&id=63fdeb4e"
import script from "./LegBonusUpdateForm.vue?vue&type=script&lang=js"
export * from "./LegBonusUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports